﻿import { debug } from 'util';
import { CommonService } from '../../services/common_services/common.service';
// import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar';
import { NgbDatepickerConfig, NgbDateStruct, NgbCalendar, NgbDate, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input, AfterContentInit, Output, EventEmitter, Injectable } from '@angular/core';
import { LoaderindicatorService } from '../../services/loaderindicator/loaderindicator.service';
import { DataCommunicationService } from '../../services/data_service/data-communication.service';
import { ToastrService } from 'ngx-toastr';
// import {  } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { NgbDatepickerNavigateEvent } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker';
import { TranslateService } from '@ngx-translate/core';

const I18N_VALUES = {
  // tslint:disable-next-line:object-literal-key-quotes
  'no': {
    weekdays: ['Man', 'Tirs', 'Ons', 'Tors', 'Fre', 'Lør', 'Søn'],
    months: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'],
  },
};

// Define a service holding the language. You probably already have one if your app is i18ned. Or you could also
// use the Angular LOCALE_ID value
@Injectable()
export class I18n {
  language = 'no';
}

// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  
  // tslint:disable-next-line:variable-name
  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

@Component({
  selector: 'mgfw-appointment-date-picker',
  templateUrl: './appointment-date-picker.component.html',
  styleUrls: ['./appointment-date-picker.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class AppointmentDatePickerComponent implements OnInit, AfterContentInit {

  startDate: { year: number; month: number };
  count: number;
  currentMonth: any;
  weekdends = [];
  weekendDaysList = [];
  model: NgbDateStruct;
  dealerName: string;
  UnAvailableDatesOccupied = [];
  currentDate = new Date();
  availableDates: NgbDateStruct[] = [];
  isArrows: string;
  firstDayOfWeek: number;
  nextdateEvent: NgbDatepickerNavigateEvent;
  calculatedDate = new Date();
  pastDaysList = [];
  isDisabled = false;
  availabledateascopy = [];
  PkkService = false;
  date: { year: number, month: number, day: number };

  @Output() selectedDate = new EventEmitter<Date>();
  

  constructor(
    private config: NgbDatepickerConfig,
    private calendar: NgbCalendar,
    private commonService: CommonService,
    private loaderservice: LoaderindicatorService,
    private dataCommunicationService: DataCommunicationService,
    private translate: TranslateService,
  ) {
    this.isArrows = 'arrows';
    this.firstDayOfWeek = 1;
    config.outsideDays = 'collapsed';
    this.dealerName = this.commonService.getLocalStorage('dealername');
    // this.findWeekends();
    this.UnavailableDates();

    const twoDayLatter = this.computeDate(new Date());
    this.calculatedDate = twoDayLatter;
    config.minDate = { year: twoDayLatter.getFullYear(), month: Number(twoDayLatter.getMonth()) + 1, day: Number(twoDayLatter.getDate()) };
    config.maxDate = { year: 2099, month: 1, day: 31 };
  }

  public computeDate(date) {
    date.setDate(date.getDate() + Number(this.commonService.getLocalStorageByKey('dealerConfig', 'LeadTime')));
    if (date.getDay() == 5) {
      date.setDate(date.getDate() + 3);
    } else if (date.getDay() == 6) {
      date.setDate(date.getDate() + 2);
    } else {
      date.setDate(date.getDate() + 1);
    }

    return date;
  }
  isUnAvailableDate = (date: NgbDate, current: { month: number }) => {
    const dt = new Date(date.toString());
    if ((this.UnAvailableDatesOccupied.find(x => NgbDate.from(x).equals(date)))) {
      return true;
    }
    return false;
  }
  isWeekend = (date: NgbDate, current: { month: number }) => {
    // const dt = new Date(date.toString());
    const dt = new Date(this.commonService.changeDateFormat(date, 'yyyy-mm-dd'));
    // this.ConfirmService(dt.getMonth() + 1, dt.getFullYear(), '2');
    // this.getWeekEnds(dt);
    if (dt.getDay() === 0 || dt.getDay() === 6) {
      return true;
    } else if ((this.availableDates.some(x => NgbDate.from(x).equals(date)))) {
      this.availabledateascopy.push(date)
      return false;
    }
    else {
      return true;
    }

  }

  dateNavigate($event: NgbDatepickerNavigateEvent) {
    // to remove below comment in main application all comments
    this.UnavailableDates();
    // if ($event.current == undefined) {
    //   // this.availableDates = [];
    //   let month = $event.next.month+1;
    //   let year = $event.next.year;
    //   if(month == 13){
    //     month = 1;
    //     year = Number(year)+1;
    //   }
    //   this.ConfirmService(month, year, '3');
    // } else if ($event.next.month < $event.current.month) {
    //   //this.availableDates = [];
    //   let month = $event.next.month+1;
    //   let year = $event.next.year;
    //   if(month == 13){
    //     month = 1;
    //     year = Number(year)+1;
    //   }
    //   //this.ConfirmService(month, year, '3');
    //   this.ConfirmService($event.next.month, $event.next.year, '3');
    // } else {
    //   //this.availableDates = [];
    //   let month = $event.next.month+1;
    //   let year = $event.next.year;
    //   if(month == 13){
    //     month = 1;
    //     year = Number(year)+1;
    //   }
    //   this.ConfirmService(month, year, '3');
    //   //this.ConfirmService($event.next.month - 1, $event.next.year, '3');
    // }
    // // const onemonthLater = new Date();
    // // onemonthLater.setMonth(onemonthLater.getMonth() + 1);
    // // if (Number(onemonthLater.getMonth() + 1) > 12) {
    // //   this.ConfirmService(1, onemonthLater.getFullYear(), '4');
    // // } else {
    // //   this.ConfirmService(Number(onemonthLater.getMonth() + 1), onemonthLater.getFullYear(), '4');
    // // }


  }

  private UnavailableDates() {
    const AvailableDates = this.commonService.getLocalStorage('AvailableDates');

    // this.dealerName = this.commonService.getLocalStorage('dealername');
    if (AvailableDates !== undefined) {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < AvailableDates.length; i++) {
        const avalibledate = new Date(AvailableDates[i]);
        // tslint:disable-next-line:max-line-length
        const eachdate = { year: avalibledate.getFullYear(), month: avalibledate.getMonth() + 1, day: avalibledate.getDate() };
        this.availableDates.push(eachdate);
      }
    }
    // if (UnAvailableDatesForOccupied !== undefined) {
    //   // tslint:disable-next-line:prefer-for-of
    //   for (let i = 0; i < UnAvailableDatesForOccupied.length; i++) {
    //     const unavalibledate = new Date(UnAvailableDatesForOccupied[i]);
    //     // tslint:disable-next-line:max-line-length
    //     const eachdate = { year: unavalibledate.getFullYear(), month: unavalibledate.getMonth() + 1, day: unavalibledate.getDate() };
    //     if (new Date(UnAvailableDatesForOccupied[i]) > new Date()) {
    //       this.disabledDates.push(eachdate);
    //       this.UnAvailableDatesOccupied.push(eachdate);
    //     }
    //   }
    // }
    // console.log(this.disabledDates)
  }

  getWeekEnds(currentDate) {
    this.weekdends = [];
    const daysinMonth = this.daysInMonth(currentDate.getMonth() - 1, currentDate.getFullYear());
    for (let i = 1; i <= daysinMonth; i++) {    // looping through days in month
      const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), i);
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.weekendDaysList.length; i++) {
        if (newDate.getDay() === this.weekendDaysList[i]) {
          this.weekdends.push(newDate.getDate());
        }

      }
    }

  }


  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }
  private findWeekends() {
    this.weekendDaysList = [];
    const findWeekends = this.commonService.getLocalStorage('WeekDayList');
    // for (let i = 1; i <=1; i++) {
    if (!findWeekends.find(x => x === 'Monday')) {
      this.weekendDaysList.push(1);
    }
    if (!findWeekends.find(x => x === 'Tuesday')) {
      this.weekendDaysList.push(2);
    }
    if (!findWeekends.find(x => x === 'Wednesday')) {
      this.weekendDaysList.push(3);
    }
    if (!findWeekends.find(x => x === 'Thursday')) {
      this.weekendDaysList.push(4);
    }
    if (!findWeekends.find(x => x === 'Friday')) {
      this.weekendDaysList.push(5);
    }
    if (!findWeekends.find(x => x === 'Saturday')) {
      this.weekendDaysList.push(6);
    }
    if (!findWeekends.find(x => x === 'Sunday')) {
      this.weekendDaysList.push(0);
    }
  }
  private ConfirmService(month, year, where) {

    // if (this.currentMonth === month && this.count === 2) {
    //   return;
    // }
    // if (this.commonService.getLocalStorage('SelectedEUService')) {
    //   this.PkkService = true;
    // }

    // const appointmentCheckAvailabilityRequest: any = [];
    // appointmentCheckAvailabilityRequest.TotalDuration = this.commonService.getLocalStorageitem('totalTime')
    // appointmentCheckAvailabilityRequest.PkkService = this.PkkService;
    // appointmentCheckAvailabilityRequest.LicensePlate = this.commonService.getLocalStorageByKey('vehicleData', 'LicensePlateNo');
    // appointmentCheckAvailabilityRequest.Make = this.commonService.getLocalStorageByKey('vehicleData', 'BrandName'),
    // appointmentCheckAvailabilityRequest.DealerId = this.commonService.getLocalStorage('dealername');
    // appointmentCheckAvailabilityRequest.StartDate = year + '-' + (month > 9 ? month : '0'+month) + '-01';
    // if (this.commonService.getLocalStorageitem('waitingTime') != undefined &&
    //   this.commonService.getLocalStorageitem('waitingTime') != null && this.commonService.getLocalStorageitem('waitingTime') != '') {
    //   appointmentCheckAvailabilityRequest['WaitTimeDropTime'] = this.commonService.getLocalStorageitem('waitingTime')
    // } else if (this.commonService.getLocalStorageitem('DropTime') != undefined &&
    //   this.commonService.getLocalStorageitem('DropTime') != null && this.commonService.getLocalStorageitem('DropTime') != '') {
    //   appointmentCheckAvailabilityRequest['WaitTimeDropTime'] = this.commonService.getLocalStorageitem('DropTime')
    // }

    // this.translate.get('LoaderText.loading').subscribe(message => {
    //   this.loaderservice.show(message);
    // });
    this.UnavailableDates();
    // this.commonService.removeLocalStorage(['AvailableDates'])
    // this.dataCommunicationService.checkAppointmentAvability(appointmentCheckAvailabilityRequest).subscribe(
    //   result => {
    //     this.loaderservice.hide();
    //     // if (result.StatusCode === 1) {
    //     // console.log(result);
    //     // this.commonService.setLocalStorage('unAvailableDates', result.Data.UnAvailableDates);
    //     // this.commonService.setLocalStorage('UnAvailableDatesForOccupied', result.Data.UnAvailableDatesForOccupied);
    //     // this.commonService.setLocalStorage('WeekDayList', result.Data.WeekDayList);
    //     // this.findWeekends();
    //     let dts;
    //     if (this.commonService.getLocalStorage('AvailableDates')) {
    //       dts = this.commonService.getLocalStorage('AvailableDates');
    //     }
    //     else {
    //       dts = [];
    //     }
    //     for (let i = 0; i < result.AvailableDates.length; i++) {
    //       dts.push(result.AvailableDates[i])
    //     }
    //     this.commonService.setLocalStorage('AvailableDates', dts);
    //     this.UnavailableDates();
    //     // this.getWeekEnds(new Date());
    //     this.count = 0;
    //     //this.isDisabled = false;
    //     // } else {
    //     //   this.commonService.getErrorMessage(result.message);
    //     //   this.loaderservice.hide();
    //     // }
    //   }, error => {
    //     // this.commonService.getErrorMessage('LoaderText.AlertMsg');
    //     this.isDisabled = true;
    //     this.commonService.getErrorMessage("LoaderText.DMSDown");
    //     this.loaderservice.hide();
    //   }
    // );
  }

  public onDateSelect($event) {
    // this.ConfirmService($event.month , $event.year , '3')
    this.selectedDate.emit($event);
  }

  ngOnInit() {
    this.count = 0;
    if (this.commonService.getLocalStorage('AppointDate')) {
      this.model = this.commonService.getLocalStorage('AppointDate');
      this.onDateSelect(this.model);
    }
    else {
      this.model = this.availableDates[0];
      //console.log(this.availableDates)
      this.onDateSelect(this.model);
    }
    if(this.model != null){
      this.startDate = { year: this.model.year, month: this.model.month };
    }
    // tslint:disable-next-line:max-line-length
    for (let i = 1; i < this.calculatedDate.getDate(); i++) {
      const eachdate = { year: this.calculatedDate.getFullYear(), month: this.calculatedDate.getMonth() + 1, day: i };
      this.pastDaysList.push(eachdate);
    }


    //   this.model = this.commonService.getLocalStorage('AppointDate');
    //   if (this.commonService.getLocalStorageByKey('AppointDate', 'month') === this.commonService.getCurrentMonth().toString())
    //   {

    //    // this.model = this.commonService.getLocalStorage('AppointDate');
    //     this.model = this.calendar.getToday();
    //   }
    //   else
    //    {
    // //     current: {year: number, month: number};
    // // next: {year: number, month: number};
    // // preventDefault: () => void;

    //     // this.dateNavigate(this.nextdateEvent)
    //   //this.model = this.commonService.getLocalStorage('AppointDate');
    //   }
  }

  ngAfterContentInit(): void {

  }

  GetCssClass(date) {
    const unAvailableDates = this.commonService.getLocalStorage('unAvailableDates');
    const UnAvailableDatesForOccupied = this.commonService.getLocalStorage('UnAvailableDatesForOccupied');

    const dt = new Date(this.commonService.changeDateFormat(date, 'yyyy-mm-dd'));

    // if ((this.disabledDates.find(x => NgbDate.from(x).equals(date)))) {
    //   return true;
    // }
    // this.getWeekEnds(new Date(this.commonService.changeDateFormat(date, 'yyyy-mm-dd')));
    // if(date.day==28|| date.day==27)
    // return "AvailableDate";
    // else if((this.UnAvailableDatesOccupied.find(x => NgbDate.from(x).equals(date))) ||  this.currentDate.getDate()==date.day || this.currentDate.getDate()==23)
    // return "Occupied";
    // else if (this.weekdends.find(x => x === date.day) || this.pastDaysList.find(x=>x.day==date.day && x.month==date.month))
    // return "closed";
    // else return "";
    if (dt.getDay() === 0 || dt.getDay() === 6 || this.pastDaysList.find(x => x.day == date.day && x.month == date.month)) {

    } else if ((this.availabledateascopy.find(x => NgbDate.from(x).equals(date)))) { return 'AvailableDate'; } else {
      return 'closed';
    }

  }

  public GetTiTle(date) {
    const dt = new Date(this.commonService.changeDateFormat(date, 'yyyy-mm-dd'));

    if (dt.getDay() === 0 || dt.getDay() === 6) {
      return 'Closed';
    } else if (this.pastDaysList.find(x => x.day == date.day && x.month == date.month)) {
      return 'Past Date';
    } else if ((this.availabledateascopy.find(x => NgbDate.from(x).equals(date)))) { return 'AvailableDate'; } else {
      return 'closed';
    }
  }
  // getDotInCalender(date) {
  //   const dt = new Date(date.toString());
  //   if ((this.disabledDates.find(x => NgbDate.from(x).equals(date)))) {
  //     return true;
  //   }
  //   return false;
  // }

}
